<template>
    <div>
        <a-modal :visible="isShow" width="960px" title="自定义吊牌" :footer="null" @cancel="cancel" class="tag_modal">
            <p class="tip">说明：通用吊牌，用户可自定义设置吊牌标签内容，每个吊牌收取0.1元手续费</p>
            <div class="btn_wrapper">
                <a-button class="btn_add" @click="toAddTag"><img src="~@/assets/images/function-service/ic_add.png" width="12px" height="12px" />新增吊牌</a-button>
                <span class="btn_refresh" @click="refresh">
                    <img src="~@/assets/images/deal-manage/ic_refresh.png" width="16" height="16" :class="{'refreshing':isRefreshing }">刷新
                </span>
            </div>
            <a-radio-group v-model="curTag" class="table_wrapper">
                <a-table :data-source="tagList" :columns="columns" :pagination="false" rowKey="id" :customRow="(record)=>{return {on:{click:()=>this.curTag = record.id}}}">
                    <template #radio="_,record">
                        <a-radio :value="record.id" />
                    </template>
                    <template #content_list="_,record">
                        <span>{{showContent(record.content)}}</span>
                    </template>
                </a-table>
                <infinite-loading @infinite="loadMore" :distance="54" spinner="spiral" ref="infinite">
                    <div slot="no-more" class="mt10">已加载到最后</div>
                    <span slot="no-results"></span>
                </infinite-loading>
            </a-radio-group>
            <div class="btn_confirm">
                <a-button @click="cancel">取消</a-button>
                <a-button type="primary" class="ml20" @click="ok">确定选择</a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
    name: 'CustomTagModal',
    components: { InfiniteLoading },
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        selectTag: {
            type: Object | null
        }
    },
    data () {
        return {
            columns: [
                {
                    dataIndex: 'radio',
                    width: '5%',
                    align: 'center',
                    scopedSlots: { customRender: 'radio' }
                },
                {
                title: '标题',
                    dataIndex: 'name',
                    width: '15%',
                    align: 'center',
                },
                {
                    title: '内容',
                    dataIndex: 'content',
                    width: '60%',
                    align: 'center',
                    scopedSlots: { customRender: 'content_list' }
                },
            ],
            tagList: [],
            pageSize: 10,
            currentPage: 1,
            total: 0,
            curTag: null,
            isRefreshing: false
        }
    },
    methods: {
        loadMore ($state) {
            this.getTagList().then(list => {
                if (list.length > 0) {
                    this.tagList = this.tagList.concat(list)

                    if (this.tagList.length >= this.total) {
                        $state.complete()
                    } else {
                        $state.loaded()
                    }
                } else {
                    $state.complete()
                }
            }).catch(() => {
                $state.loaded()
            })
        },
        getTagList () {
            return new Promise((resolve, reject) => {
                var _this = this;

                _this.$util.api('/user/tag/list',{
                    page: _this.currentPage,
                    limit: _this.pageSize
                },function(res){
                    if(res.code == 10000){
                        var list = res.data.list;
                        
                        _this.total = res.data.total;
                        _this.currentPage = _this.currentPage + 1;
                        _this.isRefreshing = false;

                        for(var i = 0; i < res.data.list.length; i++){
                            if(i == 0){
                                _this.curTag = res.data.list[i].id;
                                break;
                            }
                        }

                        resolve(list)
                    }
                });
            })
        },
        refresh () {
            this.isRefreshing = true
            this.currentPage = 1
            this.tagList = []
            this.$refs.infinite.$emit('$InfiniteLoading:reset')
        },
        toAddTag () {
            this.$router.push('/tag/add')
        },
        ok () {
            var tag = null;

            for(var i = 0; i < this.tagList.length; i++){
                if(this.curTag == this.tagList[i].id){
                    tag = {
                        id: this.tagList[i].id,
                        name: this.tagList[i].name,
                        price: this.tagList[i].price
                    };

                    break;
                }
            }
            
            this.$emit('change', tag)
            this.cancel()
        },
        cancel () {
            this.$emit('hidden', false)
        },
        showContent (list) {
            var content = "";

            for(var i = 0; i < list.custom.length; i++){
                if(list.custom[i].content != ''){
                    content += list.custom[i].content + ';';
                }
            }
            
            return content
        },
    },
    watch: {
        selectTag: {
            handler (val) {
                this.curTag = val != null ? val.id : null
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style scoped>
.table_wrapper {
    width: 100%;
    height: 378px;
    overflow: auto;
}

.tag_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.btn_add {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fd5902;
    /* padding: 0 9px; */
}
.btn_add img {
    margin-right: 5px;
}

.tag_modal >>> .ant-table-thead th {
    background: #ffffff;
}

.tag_modal >>> .ant-table-tbody tr:nth-child(odd) {
    background: #fafafa;
}

.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    height: 35px;
    width: 100px;
}
.tip {
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
}
.btn_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.btn_refresh {
    display: inline-flex;
    align-items: center;
    color: #5388ff;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
}
.btn_refresh img {
    margin-right: 5px;
}
.refreshing {
    animation: rotate 1s ease-in-out infinite;
}
@keyframes rotate {
    to {
        transform: rotate(0deg);
    }
    from {
        transform: rotate(-360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/CustomTagModal.vue